var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, EventEmitter, OnInit, Renderer2, } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatMenuTrigger, MatTooltip } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../../config/config';
import { VisitorCalendarActionCommand, } from '../../../../commands/pagination.query.command';
import { CreateTripCommand, TripStorageCommand } from '../../../../commands/visitor/create.trip.command';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData, } from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { CreateTripModalComponent } from '../../../../common/components/create.trip.modal/create.trip.modal.component';
import { CreateTripModalActions } from '../../../../common/components/create.trip.modal/create.trip.modal.provider';
import { MobileIFrameExportPdfAlertModal } from '../../../../common/components/mobile.iframe.export.pdf.alert.modal/mobile.iframe.export.pdf.alert.modal';
import { MobileIFrameExportPdfAlertModalData } from '../../../../common/components/mobile.iframe.export.pdf.alert.modal/mobile.iframe.export.pdf.alert.modal.provider';
import { SocialLoginPopupComponent } from '../../../../common/components/social.login.popup/social.login.popup.component';
import { HubVisitorDataSource } from '../../../../models/hub/hub.visitor.data.source';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { PlaceService } from '../../../../services/place.service';
import { PDFSettingCommand } from '../../../hub/export.pdf.modal/export.pdf.modal.provider';
import { bindFunctionsToThis, clone, isNullOrUndefined } from '../../../../common/extensions';
import { GoogleMapsService } from '../../../../common/services/google.maps.service';
import { ModalService } from '../../../../common/services/modal.service';
import { HubEvent } from '../../../../models/hub/hub.event';
import { HubPlace } from '../../../../models/hub/hub.place';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { EventTimeService } from '../../../../services/event.time.service';
import { ExportService, PDFType } from '../../../../services/export.csv.service';
import { ImageService } from '../../../../services/image.service';
import { LocalStorageService } from '../../../../services/localStorageService';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { AllFrontendSettingsStore, VisitorDataCache, VisitorTripNotifyAddOrRemoveItemStore, VisitorTripStore, } from '../../../../stores/visitor.calendar.store';
import { guid } from '../../../../utils/guid';
import { AttractionListComponent } from '../../../hub/tours/attractions/attraction.list.component';
import { EventDetailsModalComponent } from '../../event.details.modal/event.details.modal.component';
import { EventDetailsModalActions } from '../../event.details.modal/event.details.modal.provider';
import { PlaceDetailsModalComponent } from '../../place.details.modal/place.details.modal.component';
import { PlaceDetailsModalActions } from '../../place.details.modal/place.details.modal.provider';
import { ShareTripModalComponent } from '../share.trip.modal/share.trip.modal.component';
import { ShareTripModalActions, ShareTripModalData } from '../share.trip.modal/share.trip.modal.provider';
import { TripDetailModalComponent } from '../trip.detail.modal/trip.detail.modal.component';
import { TripDetailModalActions, TripDetailModalData } from '../trip.detail.modal/trip.detail.modal.provider';
import { TripFloatDetailComponent } from '../trip.float.detail/trip.float.detail.component';
import { VisitorTripComponent } from '../visitor.trip.component';
import { StyleModel } from '../../../../commands/hub/style.command';
import { getRouteUrl, routeConfigs } from '../../../../common/constants/route.config';
import { CustomDefaultPlaceCategoryAccordionComponent } from '../../../hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component.';
var VisitorTripSideBarComponent = /** @class */ (function (_super) {
    __extends(VisitorTripSideBarComponent, _super);
    function VisitorTripSideBarComponent(router, imageService, visitorApiService, googleMapService, render, exportService, visitorTripStore, parent, modalService, allFrontendSettingsStore, notifyAddOrRemoveItemStore, customizationApiService, formBuilder, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.imageService = imageService;
        _this.visitorApiService = visitorApiService;
        _this.googleMapService = googleMapService;
        _this.render = render;
        _this.exportService = exportService;
        _this.visitorTripStore = visitorTripStore;
        _this.parent = parent;
        _this.modalService = modalService;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.notifyAddOrRemoveItemStore = notifyAddOrRemoveItemStore;
        _this.customizationApiService = customizationApiService;
        _this.formBuilder = formBuilder;
        _this.activatedRoute = activatedRoute;
        _this.pdfSettings = new PDFSettingCommand();
        _this.currentTripIndex = -1;
        _this.defaultTripName = 'Day ';
        _this.maxTripCount = config.tripPlanner.maxTripCount;
        _this.tripCount = 0;
        _this.displayingOn = 'feed';
        _this.category = {
            event: 'All',
            place: 'Dining & Nightlife',
        };
        _this.defaultPlaceCategory = 'Dining & Nightlife';
        _this.isLoadingAllPlaces = false;
        _this.isPlanStarted = false;
        _this.isSwitching = false;
        _this.isOpeningTrip = false;
        _this.isPlaceStartPageShown = false;
        _this.isShowFilter = false;
        _this.isEditTripModes = [];
        _this.isEditTripMode = false;
        _this.isShortPlaceDescription = false;
        _this.placeCategoryCount = 0;
        _this.filter = {
            isInitialStatus: true,
            eventAll: true,
            event: {
                art: { key: 'Arts', value: true },
                meeting: { key: 'Conferences & Meetups', value: true },
                classes: { key: 'Classes & Workshops', value: true },
                entertainment: { key: 'Entertainment', value: true },
                festival: { key: 'Festivals', value: true },
                food: { key: 'Food & Drinks', value: true },
                neighborhood: { key: 'Neighborhood', value: true },
                shopping: { key: 'Shopping', value: true },
                sport: { key: 'Outdoors & Fitness', value: true },
                other: { key: 'Other', value: true },
            },
            placeAll: true,
            place: {
                dining: { key: 'Dining & Nightlife', short: 'Dine', value: true },
                accommodation: { key: 'Accommodations', short: 'Stay', value: false },
                art: { key: 'Arts & Culture', short: 'Arts', value: false },
                shopping: { key: 'Shopping', short: 'Shop', value: false },
                activity: { key: 'Activities', short: 'Activities', value: false },
                outdoor: { key: 'Outdoors', short: 'Outdoors', value: false },
                wellness: { key: 'Wellness', short: 'Wellness', value: true },
                entertainment: { key: 'Entertainment', short: 'Entertainment', value: false },
                travel: { key: 'Transportation', short: 'Travel', value: false },
                other: { key: 'Other', short: 'Other', value: false },
                thingsToDo: { key: 'ThingsToDo', short: 'things to do', value: false },
                beauty: { key: 'Beauty', short: 'Beauty', value: false },
                car: { key: 'Cars & Motor Services', short: 'Cars', value: false },
                cleaning: { key: 'Cleaning Services', short: 'Cleaning', value: false },
                pet: { key: 'Pet Services', short: 'Pets', value: false },
                drug: { key: 'Convenience & Pharmacies', short: 'Pharmacies', value: false },
                otherTypes: { key: 'Other Types', short: 'Other types', value: false },
            },
        };
        _this.today = new Date();
        _this.tourSideImg = config.tripPlannerTourSideImg;
        _this.tripImages = [config.defaultImageUrl]; //config.tripPlanner.tripImages;
        _this.tripImageIndex = 0;
        _this.placeCategoryStartImg = config.tripPlanner.placeCategoryStartPage;
        _this.actionCommand = new VisitorCalendarActionCommand();
        _this.paginationIndex = 0;
        _this.paginationPageLimit = 10;
        _this.paginationPageLimitForEvents = _this.isMobile ? 10 : 32;
        _this.paginationPageLimitForPlacesOnDesktop = 32;
        _this.cardCountInRow = 4;
        _this.cardCountInRowForMobileEvent = 1;
        _this.cardCountInRowForMobilePlace = 2;
        _this.isPaginationInitStatus = true;
        _this.isDownloadingPDF = false;
        _this.isSearch = false;
        _this.noMoreNext = false;
        _this.noMoreBack = true;
        _this.filterDateRangeText = '';
        _this.detailsStyle = 'popup';
        _this.logoUrl = '';
        _this.placeCategoryHeight = '38px';
        _this.placeCategoryHeightMobile = '38px';
        _this.cardContainerPlaceHeight = '489px';
        _this.cardContainerPlaceFullHeight = 'none'; //'356px';
        _this.cardContainerMaxHeight = '548px';
        _this.cardContainerMaxHeightForTrip = '507px';
        _this.cardContainerFullHeight = '548px';
        _this.cardContainerFullHeightForNoPagging = '500px';
        _this.tourSpinner = [];
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.dataSource = new HubVisitorDataSource();
        _this.analytics = new HubAnalytics();
        _this.style = new StyleModel();
        _this.openMap = new EventEmitter();
        _this.hideMap = new EventEmitter();
        _this.onMapReady = new EventEmitter();
        _this.tripListReordered = new EventEmitter();
        _this.showInfoWindowOnMap = new EventEmitter();
        _this.removeFromTripEvent = new EventEmitter();
        _this.showTourWaterfall = new EventEmitter();
        _this.onFloatDetailShown = new EventEmitter();
        _this.onFloatDetailClosed = new EventEmitter();
        _this.onFloatDetailFeedsClosed = new EventEmitter();
        _this.onFloatDetailPlaceFeedsRetrieved = new EventEmitter();
        bindFunctionsToThis(_this);
        return _this;
    }
    VisitorTripSideBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.placeCategoryStartImg = this.imageService.imageSourceUrl(this.placeCategoryStartImg);
        this.tripFormGroup = this.formBuilder.group({
            tripTitle: [null],
        });
        this.isShortPlaceDescription = window.innerWidth < 365;
        this.events = [];
        this.places = [];
        setTimeout(function () {
            _this.setFacebookUserID();
        });
        this.listenShowOnMap();
        this.takeSettingsAndProcess();
    };
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "displayingOnColor", {
        get: function () {
            var key = ['event', 'place', 'tour', 'trip'].indexOf(this.displayingOn) < 0 ? 'event' : this.displayingOn;
            return this.style.tripPlanner[key].color.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "isShowThingsToDo", {
        get: function () {
            return (this.featuresToggle.placeCategory.activity ||
                this.featuresToggle.placeCategory.art ||
                this.featuresToggle.placeCategory.outdoor ||
                this.featuresToggle.placeCategory.entertainment);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "isShowingEventOrPlace", {
        get: function () {
            return this.displayingOn === 'event' || this.displayingOn === 'place';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "isAllPlaceCategoriesTurnedOff", {
        get: function () {
            return PlaceService.isAllCategoriesTurnedOff(this.featuresToggle.placeCategory);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "listTitle", {
        get: function () {
            if (this.displayingOn === 'tour') {
                if (this.parent.isForTourList && this.currentTour) {
                    return 'Back to All Itineraries';
                }
                if (this.featuresToggle.multipleCities) {
                    return this.parent.isForTourList ? 'All Itineraries' : 'Regional Itineraries';
                }
                return 'Itineraries';
            }
            if (this.displayingOn === 'trip') {
                return 'my trips';
            }
            return this.displayingOn + 's';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "isEventEnabled", {
        get: function () {
            return this.featuresToggle.manualEvents || this.featuresToggle.eventByGeolocation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "isPlaceEnabled", {
        get: function () {
            return this.featuresToggle.placeCalendar;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "isNoItem", {
        get: function () {
            return ((this.displayingOn === 'event' && !this.events.length) ||
                (this.displayingOn === 'place' && !this.places.length) ||
                (this.displayingOn === 'tour' && !this.tours.length));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "isNoTrip", {
        get: function () {
            return this.displayingOn === 'trip' && (!this.trips || !this.trips.length);
        },
        enumerable: true,
        configurable: true
    });
    VisitorTripSideBarComponent.prototype.FBLoggedIn = function () {
        this.setFacebookUserID();
    };
    VisitorTripSideBarComponent.prototype.showRouteOnMapForMobile = function () {
        if (this.displayingOn === 'trip') {
            this.parent.showDirectionMap(this.currentTrip);
        }
        else if (this.displayingOn === 'tour') {
            this.parent.showDirectionMap(this.currentTour);
        }
    };
    VisitorTripSideBarComponent.prototype.switchToEvents = function (isFirstTime) {
        var _this = this;
        if (isFirstTime === void 0) { isFirstTime = false; }
        if (!isFirstTime && this.displayingOn === 'event') {
            return;
        }
        this.parent.direction && this.parent.direction.isStarted && this.parent.direction.stopPlan();
        this.detailsPanel.closeDetails();
        this.parent.searchText = null;
        this.parent.isSearchDisabled = false;
        this.isSearch = false;
        this.cardWrap.nativeElement.style.overflowY = 'auto';
        this.paginationPageLimit = this.paginationPageLimitForEvents;
        //if (!this.category.event) {
        // this.displayingOn = 'event';
        //
        // this.toggleFilter(true);
        //     this.events = [];
        //     this.showingCount = null;
        //     this.cardWrap.nativeElement.style.maxHeight = '564px';
        //     if (this.isShowFilter) {
        //         this.filterElement.nativeElement.style.height = '280px';
        //     }
        //}
        this.isSwitching = true;
        this.getEventsFromCache().subscribe(function (data) {
            _this.afterGotEvents(data);
        });
    };
    VisitorTripSideBarComponent.prototype.switchToPlaces = function (isShowSpinner, feedId, isGotoTours) {
        var _this = this;
        if (isShowSpinner === void 0) { isShowSpinner = true; }
        if (feedId === void 0) { feedId = null; }
        if (isGotoTours === void 0) { isGotoTours = false; }
        this.cardCountInRow = this.isMobile ? this.cardCountInRowForMobilePlace : this.cardCountInRow;
        this.parent.direction && this.parent.direction.isStarted && this.parent.direction.stopPlan();
        this.detailsPanel.closeDetails();
        this.parent.searchText = null;
        this.parent.isSearchDisabled = false;
        this.isSearch = false;
        this.parent.from = null;
        this.parent.to = null;
        this.parent.isStarted = true;
        if (!this.isMobile) {
            this.paginationPageLimit = this.paginationPageLimitForPlacesOnDesktop;
        }
        else {
            this.paginationPageLimit = this.paginationPageLimitForEvents;
        }
        if ((!this.customDefaultPlaceCategory || this.customDefaultPlaceCategory.useDefault) && !this.category.place) {
            this.places = [];
            this.placeRows = [];
            this.afterGotPlaces([]);
            return;
        }
        if (isShowSpinner) {
            this.isSwitching = true;
        }
        // if (!this.isPlaceStartPageShown) {
        //     if (!this.featuresToggle.multipleCities) {
        //         this.showPlaceCategoryStartPage();
        //     }
        // }
        if (!VisitorDataCache.placeCategories) {
            this.visitorApiService.getPlaceCategories().subscribe(function (data) {
                VisitorDataCache.placeCategories = clone(data);
                _this.procecssPlaces(feedId, isGotoTours);
            });
        }
        else {
            this.procecssPlaces(feedId, isGotoTours);
        }
        if (isGotoTours) {
            setTimeout(function () {
                _this.switchToTours();
            });
        }
    };
    VisitorTripSideBarComponent.prototype.switchToTours = function (tourId) {
        var _this = this;
        this.parent.setPDFLoadingTip([3, 4, 5, 6]); // this is a fake PDF downloading progress
        this.parent.direction && this.parent.direction.isStarted && this.parent.direction.stopPlan();
        this.isSwitching = true;
        this.detailsPanel.closeDetails();
        this.parent.searchText = null;
        this.parent.isSearchDisabled = true;
        this.isSearch = false;
        this.parent.from = null;
        this.parent.to = null;
        this.parent.isStarted = true;
        //this.cardWrap.nativeElement.style.overflowY = 'hidden';
        this.cardWrap.nativeElement.style.overflowY = 'auto';
        if (!VisitorDataCache.tours || !VisitorDataCache.tours.length) {
            this.visitorApiService.getTours(this.hubName).subscribe(function (data) {
                VisitorDataCache.tours = data;
                _this.afterGotTours(data, tourId);
            });
        }
        else {
            this.afterGotTours(VisitorDataCache.tours, tourId);
        }
    };
    VisitorTripSideBarComponent.prototype.switchToTrip = function (isShared, tripIndex) {
        if (isShared === void 0) { isShared = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if (this.isMobile)
                        // {
                        //     //this.userFacebookID = '10214072230112487';
                        //     this.displayingOn = 'trip';
                        //     this.isOpeningTrip = true;
                        //     try {
                        //         this.setFacebookUserID();
                        //         this.parent.syncTripsWithDBAsync(this.userFacebookID).subscribe(trips => {
                        //             this.afterSetTrips(isShared, tripIndex);
                        //             this.isOpeningTrip = false;
                        //         });
                        //     } catch (ex) {
                        //         this.afterSetTrips(isShared, tripIndex);
                        //         this.isOpeningTrip = false;
                        //     }
                        //
                        //     return;
                        // }
                        this.parent.setPDFLoadingTip([3, 4, 5, 6]);
                        this.setFacebookUserID();
                        return [4 /*yield*/, this.loadUserTripFromDB()];
                    case 1:
                        _a.sent();
                        this.isSearch = false;
                        this.afterSetTrips(isShared, tripIndex);
                        return [2 /*return*/];
                }
            });
        });
    };
    VisitorTripSideBarComponent.prototype.loadUserTripFromDB = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userTrip, keyWithUserID, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.userFacebookID) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.visitorApiService.getUserTrips(this.hubName, this.userFacebookID).toPromise()];
                    case 1:
                        userTrip = _a.sent();
                        keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.userFacebookID);
                        key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
                        localStorage.setItem(keyWithUserID, JSON.stringify(userTrip || ''));
                        localStorage.setItem(key, JSON.stringify(userTrip || ''));
                        this.getTripCount(this.userFacebookID);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    VisitorTripSideBarComponent.prototype.filterEvents = function () {
        var _this = this;
        this.visitorApiService
            .getEvents(this.hubName, {
            limit: config.searchLimit,
            page: 1,
            category: 'all',
            from: this.fromForMobile,
            to: this.toForMobile,
        })
            .subscribe(function (data) {
            _this.setEventDateRange(_this.fromForMobile, _this.toForMobile);
            VisitorDataCache.events = data;
            _this.afterGotEvents(data);
        });
    };
    VisitorTripSideBarComponent.prototype.showTourDetail = function (tour) {
        if (tour) {
            this.currentTour = tour;
            if (!this.isMobile) {
                this.cardWrap.nativeElement.style.overflowY = 'auto';
                this.cardWrap.nativeElement.style.maxHeight = this.cardContainerMaxHeightForTrip; //'auto !important';
                this.cardContainer.nativeElement.style.maxHeight = 'auto'; //this.cardContainerMaxHeight;
                this.cardContainer.nativeElement.style.overflowY = 'auto';
            }
            else {
                this.cardWrap.nativeElement.style.overflowY = 'hidden';
                this.cardWrap.nativeElement.style.height = 'auto';
                this.cardContainer.nativeElement.style.overflowY = 'auto';
                this.scrollToTop();
            }
        }
    };
    VisitorTripSideBarComponent.prototype.goToSubmitPage = function () {
        var path = getRouteUrl(routeConfigs.submit[this.displayingOn], {
            hubName: this.hubName,
        });
        console.log({ path: path });
        this.router.navigateByUrl(path, { skipLocationChange: this.noChangeUrlWhenRedirect });
    };
    VisitorTripSideBarComponent.prototype.pagingBack = function () {
        if (this.noMoreBack) {
            return;
        }
        this.paginationIndex--;
        var start = this.paginationPageLimit * this.paginationIndex;
        var end = start + this.paginationPageLimit;
        if (start <= 0) {
            start = 0;
            this.noMoreBack = true;
        }
        if (this.displayingOn === 'event') {
            this.events = this.allEventsOrPlaces.slice(start, end);
            this.processMultiColumnsItems();
            this.events = this.setEventMapIcon(this.events || []);
            if (!this.isMobile) {
                this.parent.showOnMap({ items: this.events, index: null });
            }
        }
        else if (this.displayingOn === 'place') {
            this.places = this.allEventsOrPlaces.slice(start, end);
            this.processMultiColumnsItems();
            if (!this.isMobile) {
                this.parent.showOnMap({ items: this.places, index: null });
            }
        }
        this.showingCount = start + 1 + " - " + end;
        this.noMoreNext = false;
        this.scrollToTop();
        this.fitBounds();
    };
    VisitorTripSideBarComponent.prototype.pagingNext = function () {
        if (this.noMoreNext) {
            return;
        }
        this.paginationIndex++;
        var start = this.paginationPageLimit * this.paginationIndex;
        var end = start + this.paginationPageLimit;
        if (end >= this.allEventsOrPlaces.length) {
            end = this.allEventsOrPlaces.length;
            this.noMoreNext = true;
        }
        if (this.displayingOn === 'event') {
            this.events = this.allEventsOrPlaces.slice(start, end);
            this.events = this.setEventMapIcon(this.events || []);
            this.processMultiColumnsItems();
            if (!this.isMobile) {
                this.parent.showOnMap({ items: this.events, index: null });
            }
        }
        else if (this.displayingOn === 'place') {
            this.places = this.allEventsOrPlaces.slice(start, end);
            this.processMultiColumnsItems();
            if (!this.isMobile) {
                this.parent.showOnMap({ items: this.places, index: null });
            }
        }
        this.showingCount = start + 1 + " - " + end;
        this.noMoreBack = false;
        this.isPaginationInitStatus = false;
        this.scrollToTop();
        this.fitBounds();
    };
    VisitorTripSideBarComponent.prototype.onCloseFloatDetail = function () {
        this.parent.visiblePopup();
        if (this.mobileMapTrigger) {
            this.mobileMapTrigger.nativeElement.style.display = 'block';
        }
    };
    VisitorTripSideBarComponent.prototype.locateOnMap = function ($event, index) {
        if ($event && $event.address && !isNullOrUndefined($event.address.lat)) {
            var target = [];
            if (this.displayingOn === 'event') {
                target = this.events;
            }
            else if (this.displayingOn === 'place') {
                target = this.places;
            }
            this.showInfoWindowOnMap.emit({ items: target, index: index });
            //this.attractionlist.closeDetails();
        }
    };
    VisitorTripSideBarComponent.prototype.showDetails = function (item, displayingOn, isShowAddToTripBtn, index) {
        if (isShowAddToTripBtn === void 0) { isShowAddToTripBtn = true; }
        if (!item) {
            return;
        }
        if (!this.isMobile && this.detailsStyle === 'popup') {
            item['from'] = 'trip';
            item.hubName = this.hubName;
            if (displayingOn === 'place') {
                var actions = {
                    confirm: function (event, data) {
                    },
                };
                this.modalService.show({
                    component: PlaceDetailsModalComponent,
                    providers: [
                        { provide: PlaceDetailsModalActions, useValue: actions },
                        { provide: HubPlace, useValue: item },
                    ],
                    panelClass: 'modal-fixed-top',
                });
            }
            else if (displayingOn === 'event') {
                item.from = 'trip';
                var actions = {
                    confirm: function (event, data) {
                    },
                };
                this.modalService.show({
                    component: EventDetailsModalComponent,
                    providers: [
                        { provide: EventDetailsModalActions, useValue: actions },
                        { provide: HubEvent, useValue: item },
                    ],
                    panelClass: 'modal-fixed-top-lower',
                });
            }
            return;
        }
        var height = null;
        var top = '108px';
        var left = '0';
        if (!this.isMobile) {
            height = this.parent.bg.nativeElement.offsetHeight + "px";
            // top = this.featuresToggle.multipleCities ? '197px' : '99px';
            // left = 'calc(30% - 8px)';
            top = '0';
            left = 'calc(100% - 16px)';
        }
        else {
            top = '92px';
            if (this.parent.isShowDirectionMap || this.parent.isShowNormalMap) {
                top = '0px';
            }
            this.showTripDetailModalForMobile(item, displayingOn, isShowAddToTripBtn, index);
            return;
        }
        if (!this.isMobile && index !== null && index !== undefined && !item.isOnlineEvent) {
            this.locateOnMap(item, index);
            this.parent.setMapCenter(item.address.lat || item.lat, item.address.lng || item.lng);
        }
        this.detailsPanel.showDetails({ item: item, feedType: displayingOn }, left, top, height);
    };
    VisitorTripSideBarComponent.prototype.showTripDetailModalForMobile = function (item, displayingOn, isShowAddToTripBtn, index) {
        if (isShowAddToTripBtn === void 0) { isShowAddToTripBtn = true; }
        var actions = {
            confirm: function (event) {
            },
        };
        this.modalService.show({
            component: TripDetailModalComponent,
            providers: [
                { provide: TripDetailModalActions, useValue: actions },
                {
                    provide: TripDetailModalData,
                    useValue: new TripDetailModalData(item, displayingOn, this.hubName, this.parent.urlTripID, this.parent.urlTripFromUserID, isShowAddToTripBtn, index),
                },
            ],
            panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
        });
    };
    VisitorTripSideBarComponent.prototype.filterPlace = function ($event) {
        var _this = this;
        console.log($event);
        this.isSwitching = true;
        this.visitorApiService
            .getPlaces(this.hubName, {
            limit: config.placeSearchLimit,
            page: 1,
            category: null,
            categoryList: null,
            feedId: null,
            feedIds: null,
            source: this.dataSource.place,
        })
            .subscribe(function (data) {
            var places = data;
            _this.afterGotPlaces(places);
            _this.isSwitching = false;
        });
        this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.clearFilter();
        this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.close();
    };
    VisitorTripSideBarComponent.prototype.selectCustomDefaultPlaceCategory = function ($event) {
        var _this = this;
        console.log({ $event: $event });
        this.isSwitching = true;
        this.visitorApiService
            .getPlaces(this.hubName, {
            limit: config.placeSearchLimit,
            page: 1,
            category: null,
            categoryList: $event.categoryList,
            feedId: null,
            feedIds: null,
            source: this.dataSource.place,
        })
            .subscribe(function (data) {
            var places = data;
            _this.afterGotPlaces(places);
            _this.isSwitching = false;
        });
        $event && this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.setFilter($event.title);
        !$event && this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.clearFilter();
        this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.close();
    };
    VisitorTripSideBarComponent.prototype.FBLogin = function () {
        //this.parent.loginWithFBBtn.login();
    };
    VisitorTripSideBarComponent.prototype.floatDetailShown = function ($event) {
        this.onFloatDetailShown.emit($event);
    };
    VisitorTripSideBarComponent.prototype.floatDetailClosed = function ($event) {
        this.onFloatDetailClosed.emit($event);
    };
    VisitorTripSideBarComponent.prototype.floatDetailFeedsClosed = function ($event) {
        this.onFloatDetailFeedsClosed.emit($event);
    };
    VisitorTripSideBarComponent.prototype.floatDetailPlaceFeedsRetrieved = function ($event) {
        this.onFloatDetailPlaceFeedsRetrieved.emit($event);
    };
    VisitorTripSideBarComponent.prototype.showTour = function (item, index) {
        if (this.tourSpinner && this.tourSpinner.length > index) {
            this.tourSpinner[index] = true;
        }
        this.parent.showTourDetail(item);
    };
    VisitorTripSideBarComponent.prototype.hideTourSpinner = function () {
        var _this = this;
        if (this.tours && this.tours.length) {
            this.tourSpinner = [];
            this.tours.forEach(function (x) {
                _this.tourSpinner.push(false);
            });
        }
    };
    VisitorTripSideBarComponent.prototype.mapReady = function () {
        this.onMapReady.emit();
    };
    VisitorTripSideBarComponent.prototype.printTourOrTrip = function (trips, isPrintVersion, type, headerImage, $event) {
        if (type === void 0) { type = PDFType.trip; }
        if (headerImage === void 0) { headerImage = null; }
        if ($event === void 0) { $event = null; }
        var items = [];
        trips.forEach(function (trip) {
            items.push({ isTripTitle: true, tripTitle: trip.title });
            trip.attractions.forEach(function (x) {
                items.push(x.item);
            });
        });
        this.getStyleAndPrint(items, isPrintVersion, type, headerImage, $event);
    };
    VisitorTripSideBarComponent.prototype.printTrip = function (isPrintVersion, $event) {
        var _this = this;
        if (this.isMobile) {
            if (window.location !== window.parent.location) {
                console.log('iframe');
                var urlBase_1 = null;
                if (window.location.href.indexOf('/trips') > 0) {
                    urlBase_1 = window.location.href.substr(0, window.location.href.indexOf('/trips'));
                }
                else if (window.location.href.indexOf('/region') > 0) {
                    urlBase_1 = window.location.href.substr(0, window.location.href.indexOf('/region'));
                }
                var tripId_1 = guid();
                this.visitorApiService
                    .createTripTemp(this.hubName, {
                    id: tripId_1,
                    hubName: this.hubName,
                    trips: JSON.stringify(this.currentTrip || this.trips),
                })
                    .subscribe(function () {
                    _this.modalService.show({
                        component: MobileIFrameExportPdfAlertModal,
                        providers: [
                            {
                                provide: MobileIFrameExportPdfAlertModalData,
                                useValue: new MobileIFrameExportPdfAlertModalData(urlBase_1 + "/pdf/trip/" + tripId_1 + "/" + (isPrintVersion ? 'print' : 'online')),
                            },
                        ],
                    });
                });
                return;
            }
            else {
                console.log('not iframe');
            }
        }
        this.downloadingPDFSpinner();
        this.printTourOrTrip(this.currentTrip ? [this.currentTrip] : this.trips, isPrintVersion, PDFType.trip, null, $event);
    };
    VisitorTripSideBarComponent.prototype.printTour = function (isPrintVersion, $event) {
        if (!this.currentTour || !this.currentTour.attractions.length) {
            return;
        }
        if (this.isMobile) {
            if (window.location !== window.parent.location) {
                console.log('iframe');
                var urlBase = null;
                if (window.location.href.indexOf('/trips') > 0) {
                    urlBase = window.location.href.substr(0, window.location.href.indexOf('/trips'));
                }
                else if (window.location.href.indexOf('/region') > 0) {
                    urlBase = window.location.href.substr(0, window.location.href.indexOf('/region'));
                }
                this.modalService.show({
                    component: MobileIFrameExportPdfAlertModal,
                    providers: [
                        {
                            provide: MobileIFrameExportPdfAlertModalData,
                            useValue: new MobileIFrameExportPdfAlertModalData(urlBase + "/pdf/tour/" + this.currentTour._id + "/" + (isPrintVersion ? 'print' : 'online')),
                        },
                    ],
                });
                if (config.isAnalyticsOn) {
                    this.visitorApiService.addDownloadCount(this.hubName, this.currentTour._id).subscribe();
                }
                return;
            }
            else {
                console.log('not iframe');
            }
        }
        this.downloadingPDFSpinner();
        if (this.currentTour.image) {
            this.printTourOrTrip([this.currentTour], isPrintVersion, PDFType.tour, this.imageService.imageSourceUrl(this.currentTour.image), $event);
        }
        else {
            this.printTourOrTrip([this.currentTour], isPrintVersion, PDFType.tour, null, $event);
        }
        if (config.isAnalyticsOn) {
            this.visitorApiService.addDownloadCount(this.hubName, this.currentTour._id).subscribe();
        }
    };
    VisitorTripSideBarComponent.prototype.getStyleAndPrint = function (items, isPrintVersion, type, headerImage, $event) {
        var _this = this;
        if ($event === void 0) { $event = null; }
        this.customizationApiService.getStyleAndPDFSettings(this.hubName).subscribe(function (style) {
            var tripHeaderImage = (style.pdf.headerImage.tour.url && !style.pdf.headerImage.tour.isDefault) ? style.pdf.headerImage.tour.url : headerImage || null;
            _this.logoUrl =
                isNullOrUndefined(style.logo) || isNullOrUndefined(style.logo.isDefault) || style.logo.isDefault
                    ? null
                    : style.logo.url;
            _this.logo = style.logo;
            _this.parent.setPDFLoadingTip([18, 19, 20, 21]);
            _this.imageService.geetBase64ImageByUrl(_this.logoUrl).then(function (base64) {
                _this.parent.setPDFLoadingTip([23, 24, 25, 26]);
                _this.visitorApiService.convertGoogleImages(_this.hubName, items).subscribe(function (converted) {
                    _this.exportService.exportPDF(converted, type, isPrintVersion, tripHeaderImage, isNullOrUndefined(_this.logo.isDefault) || _this.logo.isDefault ? null : base64, style.URLs.eventCalendarURL, style.URLs.placeCalendarURL, style.URLs.moreToursURL, null, null, '', style.style.eventButton.backgroundColor, $event || undefined, function (progress) {
                        var per = Math.max(26, progress);
                        _this.parent.loadingTip = "Loading PDF...(" + per + "%)";
                    }, function () {
                        _this.isDownloadingPDF = false;
                        if (_this.parent.isForExportPDF) {
                            _this.parent.pageSpinner && _this.parent.pageSpinner.hide();
                        }
                    });
                });
            });
        });
    };
    VisitorTripSideBarComponent.prototype.downloadingPDFSpinner = function () {
        this.isDownloadingPDF = true;
        // setTimeout(() => {
        //     this.isDownloadingPDF = false;
        // }, this.isMobile ? 60000 : 15000);
    };
    VisitorTripSideBarComponent.prototype.filterEventsByDate = function (searchText, from, to) {
        var _this = this;
        if (this.displayingOn === 'event') {
            if (!this.category.event) {
                this.events = [];
                this.showingCount = null;
                return;
            }
            if (from) {
                from.setHours(0);
                from.setMinutes(0);
                from.setSeconds(0);
            }
            if (to) {
                to.setHours(23);
                to.setMinutes(59);
                to.setSeconds(59);
            }
            this.isSwitching = true;
            this.visitorApiService
                .getEvents(this.hubName, {
                limit: config.searchLimit,
                page: 1,
                category: this.category.event,
                search: searchText,
                from: from,
                to: to,
            })
                .subscribe(function (data) {
                EventTimeService.formatEventTime(data);
                _this.allEventsOrPlaces = data;
                _this.setPaggination(data);
                if (_this.parent.isShowNormalMap) {
                    _this.parent.start();
                }
                _this.hideMask();
            });
        }
    };
    VisitorTripSideBarComponent.prototype.search = function (searchText, from, to) {
        var _this = this;
        this.detailsPanel.closeDetails();
        if (searchText) {
            this.isSearch = true;
            this.parent.searchOnDesktop.searching = true;
        }
        else {
            this.isSearch = false;
            this.parent.searchOnDesktop.searching = false;
        }
        if (this.displayingOn === 'event') {
            if (!this.category.event) {
                this.events = [];
                this.showingCount = null;
                return;
            }
            this.isSwitching = true;
            this.visitorApiService
                .getEvents(this.hubName, {
                limit: config.searchLimit,
                page: 1,
                category: this.category.event,
                search: searchText,
                from: from,
                to: to,
            })
                .subscribe(function (data) {
                EventTimeService.formatEventTime(data);
                _this.allEventsOrPlaces = data;
                _this.setPaggination(data);
                _this.processMultiColumnsItems();
                _this.hideMask();
                _this.parent.searchOnDesktop.searching = false;
            });
        }
        else if (this.displayingOn === 'place') {
            var category = !searchText ? this.category.place : 'all';
            this.isSwitching = true;
            this.visitorApiService
                .getPlaces(this.hubName, {
                limit: config.placeSearchLimit,
                page: 1,
                category: category,
                search: searchText,
                source: this.dataSource.place,
            })
                .subscribe(function (data) {
                _this.setPlaceMapIcon(data);
                _this.allEventsOrPlaces = data;
                _this.displayingOn = 'place';
                _this.setPaggination(data);
                _this.processMultiColumnsItems();
                _this.hideMask();
                _this.parent.searchOnDesktop.searching = false;
            });
        }
    };
    VisitorTripSideBarComponent.prototype.toggleFilter = function (canDo) {
        var _this = this;
        if (!canDo) {
            return;
        }
        if (this.displayingOn === 'tour') {
            this.switchToTours();
            return;
        }
        if (this.displayingOn === 'event' || this.displayingOn === 'place') {
            // if (this.displayingOn === 'place' || (this.isMobile && this.displayingOn === 'event')) {
            this.isShowFilter = !this.isShowFilter;
            if (this.isShowFilter) {
                this.filterElement.nativeElement.style.height =
                    this.displayingOn.toString() === 'event'
                        ? '34px'
                        : this.displayingOn === 'place'
                            ? this.placeCategoryHeight
                            : '0px';
                this.filterElement.nativeElement.style.paddingTop = '16px';
                this.cardWrap.nativeElement.style.transition = '300ms all';
                if (!this.isMobile) {
                    this.cardWrap.nativeElement.style.height = this.cardContainerPlaceHeight;
                    this.cardWrap.nativeElement.style.maxHeight = this.cardContainerPlaceHeight;
                }
                else {
                    setTimeout(function () {
                        _this.scrollToTop();
                    });
                }
            }
            else {
                this.filterElement.nativeElement.style.height = '0px';
                this.filterElement.nativeElement.style.paddingTop = '0';
                this.cardWrap.nativeElement.style.transition = '300ms all';
                setTimeout(function () {
                    _this.cardWrap.nativeElement.style.height = _this.cardContainerMaxHeight;
                    //this.cardWrap.nativeElement.style.maxHeight = this.cardContainerMaxHeight;
                });
            }
        }
        setTimeout(function () {
            if (_this.displayingOn === 'event' && (!_this.events || !_this.events.length)) {
                _this.cardWrap.nativeElement.style.height = 'auto';
            }
            if (_this.displayingOn === 'place' && (!_this.places || !_this.places.length)) {
                _this.cardWrap.nativeElement.style.height = 'auto';
            }
            // fix the place list blank issue
            if (_this.displayingOn === 'place' && _this.isMobile) {
                _this.placeMask.nativeElement.style.opacity = 0.1;
                _this.placeMask.nativeElement.style.display = 'block';
                setTimeout(function () {
                    _this.placeMask.nativeElement.style.opacity = 0;
                    _this.placeMask.nativeElement.style.display = 'none';
                }, 500);
            }
        });
    };
    VisitorTripSideBarComponent.prototype.setAllPlaceCategoryUnSelected = function () {
        for (var cate in this.filter.place) {
            this.filter.place[cate].value = false;
        }
    };
    VisitorTripSideBarComponent.prototype.resetPlaceCategoty = function () {
        this.setAllPlaceCategoryUnSelected();
        this.category.place = 'Dining & Nightlife';
        this.filter.place.dining.value = true;
        this.isSearch = false;
        VisitorDataCache.places = null;
    };
    VisitorTripSideBarComponent.prototype.filterCategory = function (category, closeStartPage) {
        if (closeStartPage === void 0) { closeStartPage = false; }
        if (closeStartPage === true) {
            this.closePlaceCategoryStartPage();
            this.filter.place.dining.value = false;
        }
        // only select current category, per ITI's request
        for (var key in this.filter[this.displayingOn]) {
            if (!Object.hasOwnProperty(key)) {
                this.filter[this.displayingOn][key].value = false;
            }
        }
        if (!isNullOrUndefined(category)) {
            category.value = !category.value;
        }
        this.category[this.displayingOn] = '';
        this.equipCategory();
        this.switchToPlaces(false);
        return;
    };
    VisitorTripSideBarComponent.prototype.reordered = function ($event) {
        if (!this.trips || !$event.attractions.length) {
            return;
        }
        if ($event.type === 'trip') {
            var userID = void 0;
            if (this.isUserloggedIn) {
                userID = SocialLoginPopupComponent.userId;
            }
            var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
            var keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userID);
            var tripWithUserID = JSON.parse(localStorage.getItem(keyWithUserID));
            if (tripWithUserID && tripWithUserID.trips[this.currentTripIndex].attractions.length) {
                tripWithUserID.trips[this.currentTripIndex].attractions = $event.attractions;
                tripWithUserID.trips[this.currentTripIndex].attractions =
                    tripWithUserID.trips[this.currentTripIndex].attractions.removeDuplicate();
                tripWithUserID.timestamp = new Date();
                localStorage.setItem(key, JSON.stringify(tripWithUserID));
                localStorage.setItem(keyWithUserID, JSON.stringify(tripWithUserID));
                if (userID) {
                    this.visitorApiService.updateTrip(this.hubName, tripWithUserID).subscribe();
                }
            }
            this.trips[this.currentTripIndex].attractions = $event.attractions;
        }
        if (!this.isMobile) {
            this.tripListReordered.emit(this.trips[this.currentTripIndex]);
        }
    };
    VisitorTripSideBarComponent.prototype.removeFromTrip = function (id, tripIndex) {
        if (id) {
            if (this.isUserloggedIn) {
                this.userFacebookID = SocialLoginPopupComponent.userId;
                if (!this.parent.urlTripID || this.parent.urlTripFromUserID === this.userFacebookID) {
                    this.removeTripItemFromDB(id, !isNullOrUndefined(tripIndex) ? tripIndex : this.currentTripIndex);
                }
            }
            this.removeFromLocalStorage(id, tripIndex);
            var trip = this.getTripFromLocalStorage(this.currentTripIndex);
            this.removeFromTripEvent.emit(trip);
        }
    };
    VisitorTripSideBarComponent.prototype.tripCoverImage = function (trip) {
        if (trip && trip.attractions && trip.attractions.length) {
            return trip.attractions[0].item.cover
                ? trip.attractions[0].item.cover.source || this.tripImages[0]
                : this.tripImages[0];
        }
        return this.tripImages[0];
    };
    VisitorTripSideBarComponent.prototype.addNewTripToLocalStorage = function (title, item, type) {
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
        var keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.userFacebookID);
        var trips = JSON.parse(localStorage.getItem(key));
        var newTrip = new CreateTripCommand();
        if (!trips || !trips.trips || !trips.trips.length) {
            trips = new TripStorageCommand();
        }
        else {
            if (trips.trips.length >= this.maxTripCount) {
                return;
            }
        }
        newTrip.attractions = [];
        if (item) {
            newTrip.attractions.push({
                feedType: type,
                feedId: item._id,
                order: 1,
                item: item,
            });
        }
        newTrip.title = title;
        newTrip.timestamp = new Date();
        newTrip.hubName = this.hubName;
        newTrip.img = this.assignTripImage();
        trips.trips.push(newTrip);
        var tripsWithUserId = clone(trips);
        localStorage.setItem(key, JSON.stringify(trips));
        tripsWithUserId.userFacebookId = this.userFacebookID || null;
        localStorage.setItem(keyWithUserID, JSON.stringify(tripsWithUserId));
        return trips;
    };
    VisitorTripSideBarComponent.prototype.createTrip = function () {
        this.createNewTrip();
        //this.trips = this.setTripImages(this.trips);
        this.isEditTripModes[this.trips.length - 1] = true;
        this.isEditTripMode = true;
        this.tripTitleSelect();
        this.scrollToBottom();
    };
    VisitorTripSideBarComponent.prototype.deleteTrip = function (index, id) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                if (_this.isUserloggedIn) {
                    _this.visitorApiService
                        .deleteTrip(_this.hubName, {
                        id: id,
                        userFacebookId: _this.userFacebookID,
                    })
                        .subscribe();
                }
                var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(_this.hubName);
                var keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(_this.hubName, _this.userFacebookID);
                var trips = JSON.parse(localStorage.getItem(key));
                if (!trips || !trips.trips || !trips.trips.length) {
                    _this.trips = [];
                }
                else if (trips.trips.length === 1) {
                    localStorage.removeItem(key);
                    localStorage.removeItem(keyWithUserID);
                    _this.trips = [];
                }
                else {
                    trips.trips.splice(index, 1);
                    var tripsWithUserId = clone(trips);
                    localStorage.setItem(key, JSON.stringify(trips));
                    tripsWithUserId.userFacebookId = _this.userFacebookID || null;
                    localStorage.setItem(keyWithUserID, JSON.stringify(tripsWithUserId));
                    _this.trips = trips.trips;
                }
                if (!_this.trips.length) {
                    _this.backToWelcomePage();
                }
                //this.setTripImages(this.trips);
                _this.backToTripList();
                event.complete();
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: "Are you sure you want to remove this trip?",
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    VisitorTripSideBarComponent.prototype.isInTrip = function (tripIndex, itemId) {
        var trip = this.getTripFromLocalStorage(tripIndex);
        if (!trip) {
            return false;
        }
        return trip.attractions.any(function (x) { return x.item._id === itemId; });
    };
    VisitorTripSideBarComponent.prototype.showShareTripModal = function (type) {
        var _this = this;
        //let {tripId, hubName} = this.allRouteParams;
        var shareTripModalData = null;
        if (type === 'trip') {
            var trip = this.loadTripsInLocalStorage();
            var wholeTripId = trip ? trip.id : null;
            var singleTripId = this.currentTrip ? this.currentTrip.id : null;
            var singleTripTitle = this.currentTrip ? this.currentTrip.title : null;
            shareTripModalData = new ShareTripModalData(wholeTripId, this.hubName, type, !this.currentTrip, singleTripId, singleTripTitle, this.currentTripIndex);
        }
        else {
            shareTripModalData = new ShareTripModalData(this.currentTour._id, this.hubName, type, false, '', '', 0);
        }
        var actions = {
            confirm: function (event, social) {
                social === 'fb' ? _this.parent.socialLogin.fbLoginBtn.login() : _this.parent.socialLogin.googleLoginBtn.login();
            },
        };
        this.modalService.show({
            component: ShareTripModalComponent,
            providers: [
                { provide: ShareTripModalActions, useValue: actions },
                {
                    provide: ShareTripModalData,
                    useValue: shareTripModalData,
                },
            ],
        });
    };
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "isSharedTrip", {
        get: function () {
            return this.parent.urlTripID && this.parent.urlTripFromUserID !== this.userFacebookID;
        },
        enumerable: true,
        configurable: true
    });
    VisitorTripSideBarComponent.prototype.showCreateTripModal = function (isFromSideBar, addThisItem, type, callback) {
        var _this = this;
        if (isFromSideBar === void 0) { isFromSideBar = false; }
        if (addThisItem === void 0) { addThisItem = null; }
        if (type === void 0) { type = null; }
        if (callback === void 0) { callback = null; }
        if (this.currentTripsCount >= this.maxTripCount) {
            alert('You have created too many trips...');
            return;
        }
        var actions = {
            confirm: function (tripTitle, event) {
                _this.createNewTrip(tripTitle, addThisItem, type, callback);
                if (isFromSideBar) {
                    _this.scrollToBottom();
                }
            },
        };
        this.modalService.show({
            component: CreateTripModalComponent,
            providers: [{ provide: CreateTripModalActions, useValue: actions }],
        });
    };
    VisitorTripSideBarComponent.prototype.enterTripOrEnterEditTitle = function (index) {
        if (this.currentTrip) {
            this.enterEditTripTitleMode(index);
        }
        else {
            this.enterTrip(index);
        }
    };
    VisitorTripSideBarComponent.prototype.enterTrip = function (index) {
        var _this = this;
        if (this.isSharedTrip) {
            this.currentTrip = this.getSharedTripFromLocalStorage(index);
        }
        else {
            this.currentTrip = this.getTripFromLocalStorage(index);
        }
        this.currentTripIndex = index;
        if (!this.isMobile) {
            this.parent.showDirectionMap(this.currentTrip);
        }
        this.parent.direction && this.parent.direction.hideBanner();
        setTimeout(function () {
            if (_this.parent.isForExportPDF) {
                _this.printTrip(_this.parent.isPrintVersion);
            }
        });
    };
    VisitorTripSideBarComponent.prototype.backToTripList = function () {
        this.currentTrip = null;
        this.currentTripIndex = -1;
        this.exitEditTripTitleMode();
        if (!this.isMobile && this.parent.direction) {
            this.parent.direction.showBanner();
        }
    };
    VisitorTripSideBarComponent.prototype.backToTourList = function () {
        this.currentTour = null;
        this.currentTrip = null;
    };
    VisitorTripSideBarComponent.prototype.exitEditTripTitleMode = function () {
        var _this = this;
        this.isEditTripModes = [];
        this.trips.forEach(function () {
            _this.isEditTripModes.push(false);
        });
        this.isEditTripMode = false;
    };
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "isUserloggedIn", {
        get: function () {
            return SocialLoginPopupComponent.isUserLoggedIn;
        },
        enumerable: true,
        configurable: true
    });
    VisitorTripSideBarComponent.prototype.enterEditTripTitleMode = function (index) {
        var _this = this;
        if (!isNullOrUndefined(index)) {
            this.isEditTripModes = [];
            this.trips.forEach(function () {
                _this.isEditTripModes.push(false);
            });
            this.isEditTripModes[index] = true;
            this.isEditTripMode = true;
            this.tripTitleSelect();
        }
    };
    VisitorTripSideBarComponent.prototype.setTripTitle = function (title, index) {
        if (!isNullOrUndefined(index)) {
            if (this.isUserloggedIn) {
                this.visitorApiService
                    .updateTripTitle(this.hubName, {
                    tripIndex: index,
                    title: title,
                    userFacebookId: this.userFacebookID,
                })
                    .subscribe();
            }
            var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
            var keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.userFacebookID);
            var trips = JSON.parse(localStorage.getItem(key));
            if (trips && trips.trips && trips.trips.length > index) {
                trips.trips[index].title = title;
                var tripsWithUserId = clone(trips);
                localStorage.setItem(key, JSON.stringify(trips));
                tripsWithUserId.userFacebookId = this.userFacebookID || null;
                localStorage.setItem(keyWithUserID, JSON.stringify(tripsWithUserId));
            }
            this.isEditTripModes[index] = false;
            this.isEditTripMode = false;
        }
    };
    VisitorTripSideBarComponent.prototype.createNewTrip = function (title, addThisItem, type, callback) {
        var img = this.assignTripImage();
        var attractions = [];
        if (addThisItem) {
            attractions.push({ feedId: addThisItem._id, feedType: type, order: 1 });
        }
        if (this.isUserloggedIn) {
            this.visitorApiService
                .createTrip(this.hubName, {
                id: guid(),
                userFacebookId: this.userFacebookID,
                description: '',
                hubName: this.hubName,
                newTrip: { id: guid(), title: title || this.defaultNewTripTitle, img: img, attractions: attractions },
                trips: [],
            })
                .subscribe(function () {
            });
        }
        this.trips = this.addNewTripToLocalStorage(title || this.defaultNewTripTitle, addThisItem, type).trips;
        this.notifyAddOrRemoveItemStore.notifyCommand.next(null);
        if (callback) {
            callback();
        }
    };
    VisitorTripSideBarComponent.prototype.addItemToTrip = function (param) {
    };
    VisitorTripSideBarComponent.prototype.loadTripsInLocalStorage = function () {
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
        var trips = JSON.parse(localStorage.getItem(key));
        if (!trips || !trips.trips || !trips.trips.length) {
            trips = new TripStorageCommand();
        }
        this.trips = trips.trips;
        return trips;
    };
    VisitorTripSideBarComponent.prototype.loadTripsInLocalStorageByUserId = function () {
        var keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.userFacebookID);
        var trips = JSON.parse(localStorage.getItem(keyWithUserID));
        if (!trips || !trips.trips || !trips.trips.length) {
            trips = new TripStorageCommand();
        }
        this.trips = trips.trips;
        return trips;
    };
    VisitorTripSideBarComponent.prototype.loadSharedTripsInLocalStorage = function (userID) {
        var keyWithUserIDShared = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userID, true);
        var trips = JSON.parse(localStorage.getItem(keyWithUserIDShared));
        if (!trips || !trips.trips || !trips.trips.length) {
            trips = new TripStorageCommand();
        }
        this.trips = trips.trips;
    };
    VisitorTripSideBarComponent.prototype.removeFromLocalStorage = function (id, tripIndex) {
        this.setFacebookUserID();
        tripIndex = isNullOrUndefined(tripIndex) ? this.currentTripIndex : tripIndex;
        if (this.parent.urlTripID && this.parent.urlTripFromUserID !== this.userFacebookID) {
            var keyWithUserIDShared = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.parent.urlTripFromUserID, true);
            var trip_1 = JSON.parse(localStorage.getItem(keyWithUserIDShared));
            if (trip_1 && trip_1.attractions && trip_1.attractions.length) {
                var index = trip_1.attractions.getElementIndex(function (x) { return x.feedId === id; });
                trip_1.attractions.splice(index, 1);
            }
            trip_1.attractions = trip_1.attractions.removeDuplicate();
            if (trip_1.attractions.length) {
                trip_1.timestamp = new Date();
                localStorage.setItem(keyWithUserIDShared, JSON.stringify(trip_1));
            }
            else {
                localStorage.removeItem(keyWithUserIDShared);
            }
            this.trips = trip_1;
            return;
        }
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
        var keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.userFacebookID);
        var trip = JSON.parse(localStorage.getItem(key));
        if (!trip || !trip.trips || trip.trips.length <= tripIndex) {
            return;
        }
        if (trip.trips[tripIndex] && trip.trips[tripIndex].attractions.length) {
            var index = trip.trips[tripIndex].attractions.getElementIndex(function (x) { return x.feedId === id; });
            trip.trips[tripIndex].attractions.splice(index, 1);
        }
        trip.trips[tripIndex].attractions = trip.trips[tripIndex].attractions.removeDuplicate();
        trip.timestamp = new Date();
        localStorage.setItem(key, JSON.stringify(trip));
        localStorage.setItem(keyWithUserID, JSON.stringify(trip));
        this.trips = trip.trips;
    };
    VisitorTripSideBarComponent.prototype.setDetaultImages = function (trips) {
        trips.forEach(function (trip) {
            if (trip.attractions && trip.attractions.length) {
                trip.attractions.forEach(function (x) {
                    // for those events use default images, need to load image from events cache
                    if (!x.item.cover && x.feedType === 'event') {
                        for (var _i = 0, _a = VisitorDataCache.events; _i < _a.length; _i++) {
                            var event_1 = _a[_i];
                            if (event_1._id === x.feedId) {
                                x.item.cover = event_1.cover;
                                break;
                            }
                        }
                    }
                });
            }
        });
        return trips;
    };
    VisitorTripSideBarComponent.prototype.setTripImages = function (trips) {
        var _this = this;
        var index = 0;
        this.isEditTripModes = [];
        trips.forEach(function (x) {
            if (index < _this.tripImages.length) {
                x.img = _this.tripImages[index];
                index++;
                if (index == _this.tripImages.length) {
                    index = 0;
                }
            }
            _this.isEditTripModes.push(false);
        });
        return trips;
    };
    VisitorTripSideBarComponent.prototype.getTripFromLocalStorage = function (tripIndex) {
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
        var trip = JSON.parse(localStorage.getItem(key));
        if (!trip || !trip.trips || !trip.trips.length) {
            return null;
        }
        if (tripIndex >= trip.trips.length) {
            return null;
        }
        return trip.trips[tripIndex];
    };
    VisitorTripSideBarComponent.prototype.getSharedTripFromLocalStorage = function (tripIndex) {
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, this.parent.urlTripFromUserID, true);
        var trip = JSON.parse(localStorage.getItem(key));
        if (!trip || !trip.trips || !trip.trips.length) {
            return null;
        }
        if (tripIndex >= trip.trips.length) {
            return null;
        }
        return trip.trips[tripIndex];
    };
    VisitorTripSideBarComponent.prototype.tripTitleSelect = function () {
        var _this = this;
        setTimeout(function () {
            _this.tripTitleInput.input.nativeElement.selectionStart = 0;
        });
    };
    VisitorTripSideBarComponent.prototype.removeTripItemFromDB = function (id, tripIndex) {
        this.visitorApiService
            .removeAtractionFromTrip(this.hubName, {
            feedId: id,
            userFacebookId: this.userFacebookID,
            tripIndex: tripIndex,
        })
            .subscribe();
    };
    VisitorTripSideBarComponent.prototype.equipCategory = function () {
        this.placeCategoryCount = 0;
        for (var key in this.filter[this.displayingOn]) {
            if (!Object.hasOwnProperty(key)) {
                if (!this.filter[this.displayingOn][key].value) {
                    if (this.category[this.displayingOn].indexOf(this.filter[this.displayingOn][key].key) >= 0) {
                        this.category[this.displayingOn] = this.category[this.displayingOn].replace("," + this.filter[this.displayingOn][key].key, '');
                    }
                }
                else {
                    this.placeCategoryCount++;
                    if (this.category[this.displayingOn].indexOf(this.filter[this.displayingOn][key].key) < 0) {
                        this.category[this.displayingOn] += "," + this.filter[this.displayingOn][key].key;
                    }
                }
            }
        }
        if (this.category[this.displayingOn].startsWith(',')) {
            this.category[this.displayingOn] = this.category[this.displayingOn].substr(1);
        }
        console.log(this.category[this.displayingOn]);
    };
    VisitorTripSideBarComponent.prototype.addingAnimation = function (param) {
        var _this = this;
        if (!this.countIcon) {
            return;
        }
        this.countIcon.nativeElement.style.transition = 'none';
        this.countIcon.nativeElement.style.top = param.event.clientY - 12 + "px";
        this.countIcon.nativeElement.style.left = param.event.clientX - 12 + "px";
        this.countIcon.nativeElement.style.display = "block";
        setTimeout(function () {
            _this.countIcon.nativeElement.style.transition = 'all 0.7s cubic-bezier(.94,-0.25,.32,1.31)';
            if (_this.isMobile) {
                _this.countIcon.nativeElement.style.left = "calc(100% - 24px)";
                _this.countIcon.nativeElement.style.top = "43px";
            }
            else {
                _this.countIcon.nativeElement.style.left = "calc(30% - 25px)";
                _this.countIcon.nativeElement.style.top = "90px";
            }
        });
    };
    VisitorTripSideBarComponent.prototype.removingAnimation = function () {
        var _this = this;
        if (!this.countIcon) {
            return;
        }
        this.countIcon.nativeElement.style.transition = 'all 0.3s';
        this.countIcon.nativeElement.style.background = '#ff0000';
        if (this.countBaseIcon) {
            this.countBaseIcon.nativeElement.style.transition = 'all 0.3s';
            this.countBaseIcon.nativeElement.style.background = '#ff0000';
        }
        setTimeout(function () {
            _this.countIcon.nativeElement.style.background = '#eec30d';
            if (_this.countBaseIcon) {
                _this.countBaseIcon.nativeElement.style.background = '#eec30d';
            }
        }, 300);
    };
    VisitorTripSideBarComponent.prototype.getTripCount = function (userID) {
        this.setFacebookUserID();
        var isShared = false;
        var userFacebookID = userID || this.userFacebookID;
        if (this.parent.urlTripID && this.parent.urlTripFromUserID !== userFacebookID) {
            userFacebookID = this.parent.urlTripFromUserID;
            isShared = true;
        }
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, userFacebookID, isShared);
        var storage = localStorage.getItem(key);
        var trip = JSON.parse(storage);
        if (trip && trip.attractions && trip.attractions.length) {
            var array = trip.attractions.removeDuplicate();
            this.tripCount = array.length;
        }
    };
    VisitorTripSideBarComponent.prototype.openPrintMenu = function () {
        if (!this.isDownloadingPDF) {
            this.menuTrigger.openMenu();
        }
    };
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "defaultNewTripTitle", {
        get: function () {
            return this.defaultTripName + (this.currentTripsCount + 1);
        },
        enumerable: true,
        configurable: true
    });
    VisitorTripSideBarComponent.prototype.showPlaceCategoryStartPage = function () {
        var _this = this;
        this.placeCategoryMask.nativeElement.style.display = 'block';
        this.placeCategoryStartPage.nativeElement.style.display = 'block';
        this.placeCategoryCloseIcon.nativeElement.style.display = 'block';
        //this.placeStayStartPageIcon.nativeElement.style.display = 'block';
        if (!this.isMobile) {
            this.startPageIconWrap.nativeElement.style.display = 'block';
            setTimeout(function () {
                _this.startPageIconWrap.nativeElement.style.width = _this.cardContainer.nativeElement.clientWidth + 'px';
                _this.placeCategoryStartPageTooltip.show();
            });
        }
        this.isPlaceStartPageShown = true;
    };
    VisitorTripSideBarComponent.prototype.scrollDown = function () {
        //this.cardWrap.nativeElement.scrollTop = 1200;//this.cardWrap.nativeElement.clientHeight;
        this.cardContainer.nativeElement.style.transition = '0.3s all';
        this.cardContainer.nativeElement.scrollTop = this.cardWrap.nativeElement.clientHeight;
    };
    VisitorTripSideBarComponent.prototype.closePlaceCategoryStartPage = function () {
        this.placeCategoryMask.nativeElement.style.display = 'none';
        this.placeCategoryStartPage.nativeElement.style.display = 'none';
        this.placeCategoryCloseIcon.nativeElement.style.display = 'none';
        this.startPageIconWrap.nativeElement.style.display = 'none';
        //this.placeStayStartPageIcon.nativeElement.style.display = 'none';
        this.placeCategoryStartPageTooltip.hide();
    };
    Object.defineProperty(VisitorTripSideBarComponent.prototype, "currentTripsCount", {
        get: function () {
            var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
            var storage = localStorage.getItem(key);
            var trip = JSON.parse(storage);
            return !trip || !trip.trips || !Array.isArray(trip.trips) ? 0 : trip.trips.length;
        },
        enumerable: true,
        configurable: true
    });
    VisitorTripSideBarComponent.prototype.setPlaceMapIcon = function (places) {
        var _this = this;
        if (!VisitorDataCache.placeCategories) {
            this.visitorApiService.getPlaceCategories().subscribe(function (data) {
                VisitorDataCache.placeCategories = clone(data);
                _this.setPlaceMapIcon(places);
            });
        }
        else {
            var categories_1 = VisitorDataCache.placeCategories;
            for (var _i = 0, places_1 = places; _i < places_1.length; _i++) {
                var place = places_1[_i];
                var _loop_1 = function (category) {
                    if (!Object.hasOwnProperty(category)) {
                        if (!place.mapIcon) {
                            if (place.categoryList.any(function (x) { return categories_1[category].any(function (y) { return x === y; }); })) {
                                place.mapIcon = categories_1[category][0];
                            }
                        }
                    }
                };
                for (var category in categories_1) {
                    _loop_1(category);
                }
            }
        }
    };
    VisitorTripSideBarComponent.prototype.getPlacesFromCache = function () {
        var places = VisitorDataCache.places;
        if (places && places.length) {
            var filterByCategory = [];
            if (this.category.place && this.category.place.toLowerCase() !== 'all') {
                var categories = this.category.place.split(',');
                var _loop_2 = function (place) {
                    var _loop_3 = function (category) {
                        var categoryList = [];
                        if (category === 'ThingsToDo') {
                            categoryList.push.apply(categoryList, VisitorDataCache.placeCategories['Arts & Culture']);
                            categoryList.push.apply(categoryList, VisitorDataCache.placeCategories['Activities']);
                            categoryList.push.apply(categoryList, VisitorDataCache.placeCategories['Outdoors & Fitness']);
                            categoryList.push.apply(categoryList, VisitorDataCache.placeCategories['Entertainment']);
                        }
                        else {
                            categoryList = VisitorDataCache.placeCategories[category];
                        }
                        var categoryTextList = categoryList.map(function (x) { return x.replace(/(_)+/g, ' ').upperFirstLetter(); });
                        if (place.categoryList.any(function (x) { return categoryTextList.any(function (y) { return y === x; }) || categoryList.any(function (y) { return x === y; }); })) {
                            if (!filterByCategory.any(function (x) { return x.id === place.id; })) {
                                place.mapIcon = category === 'ThingsToDo' ? 'Activities' : category;
                                filterByCategory.push(place);
                            }
                        }
                    };
                    for (var _i = 0, categories_2 = categories; _i < categories_2.length; _i++) {
                        var category = categories_2[_i];
                        _loop_3(category);
                    }
                };
                for (var _i = 0, places_2 = places; _i < places_2.length; _i++) {
                    var place = places_2[_i];
                    _loop_2(place);
                }
            }
            else {
                filterByCategory = places;
            }
            return filterByCategory;
        }
        else if (places && !places.length) {
            return [];
        }
        return null;
    };
    VisitorTripSideBarComponent.prototype.getEventsFromCache = function () {
        var _this = this;
        return Observable.create(function (observable) {
            var events = VisitorDataCache.events;
            if (events && events.length) {
                events = _this.setEventMapIcon(events);
                observable.next(events);
                observable.complete();
            }
            else {
                _this.visitorApiService
                    .getEvents(_this.hubName, {
                    limit: config.searchLimit,
                    page: 1,
                    category: _this.category.event,
                    from: _this.fromForMobile,
                    to: _this.toForMobile,
                })
                    .subscribe(function (data) {
                    data = _this.setEventMapIcon(data);
                    VisitorDataCache.events = data;
                    observable.next(data);
                    observable.complete();
                });
            }
        });
    };
    VisitorTripSideBarComponent.prototype.setEventMapIcon = function (events) {
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event_2 = events_1[_i];
            event_2.mapIcon = 'Event';
        }
        return events;
    };
    VisitorTripSideBarComponent.prototype.assignTripImage = function () {
        if (this.tripImageIndex >= this.tripImages.length) {
            this.tripImageIndex = 0;
        }
        return this.tripImages[this.tripImageIndex++];
    };
    VisitorTripSideBarComponent.prototype.procecssPlaces = function (feedId, isGotoTours) {
        var _this = this;
        if (feedId === void 0) { feedId = null; }
        if (isGotoTours === void 0) { isGotoTours = false; }
        if (this.isLoadingAllPlaces) {
            this.isSwitching = true;
            setTimeout(function () {
                _this.procecssPlaces(feedId);
            }, 500);
            return;
        }
        // let places = this.getPlacesFromCache();
        // if (!!places) {
        //     this.afterGotPlaces(places, isGotoTours);
        // } else {
        // if client turned off the showing multiple city block section in the dashboard, then get the places within the current region
        var feedIds = null;
        if (this.parent.featuresToggle.multipleCities && !this.parent.isMultiCityBlock) {
            if (this.parent.currentRegion) {
                feedIds = this.parent.currentRegion.cities.map(function (x) { return x.id; });
            }
        }
        var categoryList;
        if (!this.customDefaultPlaceCategory.useDefault) {
            this.category.place = null;
        }
        else {
            categoryList = undefined;
        }
        this.visitorApiService
            .getPlaces(this.hubName, {
            limit: config.placeSearchLimit,
            page: 1,
            category: this.category.place,
            categoryList: categoryList,
            feedId: feedId,
            feedIds: feedIds,
            source: this.dataSource.place,
        })
            .subscribe(function (data) {
            VisitorDataCache.places = data;
            //   let places = this.getPlacesFromCache();
            var places = data;
            _this.afterGotPlaces(places, isGotoTours);
            // load all places and save to cache to enhance UX
            if (_this.customDefaultPlaceCategory.useDefault) {
                _this.isLoadingAllPlaces = true;
                setTimeout(function () {
                    _this.visitorApiService
                        .getPlaces(_this.hubName, {
                        limit: config.placeSearchLimit,
                        page: 1,
                        category: 'all',
                        feedId: feedId,
                        feedIds: feedIds,
                        source: _this.dataSource.place,
                    })
                        .subscribe(function (data) {
                        VisitorDataCache.places = data;
                        _this.isLoadingAllPlaces = false;
                        _this.isSwitching = false;
                    });
                }, 1000);
            }
        });
        // }
    };
    VisitorTripSideBarComponent.prototype.afterGotEvents = function (data) {
        EventTimeService.formatEventTime(data);
        this.allEventsOrPlaces = data;
        this.displayingOn = 'event';
        !this.isShowFilter && this.toggleFilter(true);
        this.setPaggination(data);
        this.cardCountInRow = this.isMobile ? this.cardCountInRowForMobileEvent : this.cardCountInRow;
        this.processMultiColumnsItems();
        if (this.parent.isStarted && !this.isMobile) {
            this.parent.showOnMap({ items: this.events, index: null });
        }
        if (!this.isMobile) {
            if (!data || !data.length) {
                this.cardWrap.nativeElement.style.height = 'auto';
            }
            else if (data.length <= this.paginationPageLimit) {
                this.cardContainer.nativeElement.style.maxHeight = this.cardContainerFullHeight;
                this.cardWrap.nativeElement.style.maxHeight = this.cardContainerFullHeight;
                this.cardWrap.nativeElement.style.height = this.cardContainerFullHeight;
            }
            else {
                //this.cardContainer.nativeElement.style.maxHeight = this.cardContainerMaxHeight;
                this.cardWrap.nativeElement.style.maxHeight = this.cardContainerMaxHeight;
                this.cardWrap.nativeElement.style.height = this.cardContainerMaxHeight;
            }
        }
        this.scrollToTop();
        this.hideMask();
        this.analytics = new HubAnalytics();
        this.analytics.tripPlanner.eventClickCount = 1;
        if (config.isAnalyticsOn) {
            this.visitorApiService.updateTripPlanerAnalytics(this.hubName, this.analytics).subscribe();
        }
    };
    VisitorTripSideBarComponent.prototype.afterGotPlaces = function (places, isGotoTours) {
        if (isGotoTours === void 0) { isGotoTours = false; }
        this.allEventsOrPlaces = places;
        if (isGotoTours) {
            //this.switchToTours();
            return;
        }
        this.displayingOn = 'place';
        !this.isShowFilter && this.toggleFilter(true);
        if (this.isShowFilter) {
            this.filterElement.nativeElement.style.height = this.placeCategoryHeight;
            if (this.isMobile) {
                this.filterElement.nativeElement.style.height = this.placeCategoryHeightMobile;
            }
        }
        this.setPaggination(places);
        this.processMultiColumnsItems();
        if (!this.isMobile) {
            if (!places || !places.length) {
                this.cardWrap.nativeElement.style.height = 'auto';
            }
            else if (places.length <= this.paginationPageLimit) {
                this.cardContainer.nativeElement.style.maxHeight = this.cardContainerFullHeight;
                this.cardWrap.nativeElement.style.maxHeight = this.cardContainerFullHeightForNoPagging;
            }
            else {
                this.cardWrap.nativeElement.style.maxHeight = this.cardContainerPlaceHeight;
            }
            this.cardWrap.nativeElement.style.overflowY = 'auto';
            this.cardContainer.nativeElement.style.overflowY = 'hidden';
        }
        if (!places || !places.length) {
            this.cardWrap.nativeElement.style.height = 'auto';
        }
        this.scrollToTop();
        if (!this.isMobile) {
            this.parent.showOnMap({ items: this.places, index: null });
        }
        this.hideMask();
        this.analytics = new HubAnalytics();
        this.analytics.tripPlanner.placeClickCount = 1;
        if (config.isAnalyticsOn) {
            this.visitorApiService.updateTripPlanerAnalytics(this.hubName, this.analytics).subscribe();
        }
    };
    VisitorTripSideBarComponent.prototype.processMultiColumnsItems = function () {
        var _this = this;
        var targets = [];
        targets = this.displayingOn === 'place' ? this.places : this.events;
        var columns = [];
        this.placeRows = [];
        this.eventRows = [];
        targets.forEach(function (x, index) {
            if (index && index % _this.cardCountInRow === 0) {
                _this.displayingOn === 'place' ? _this.placeRows.push(columns) : _this.eventRows.push(columns);
                columns = [];
            }
            columns.push(x);
            if (index === targets.length - 1) {
                _this.displayingOn === 'place' ? _this.placeRows.push(columns) : _this.eventRows.push(columns);
            }
        });
    };
    VisitorTripSideBarComponent.prototype.scrollToTop = function () {
        /**
         * this causes the script embed solution page jump to ImGoing, pause this for now
         * */
        // this.cardContainer.nativeElement.scrollIntoView();
        // if (this.isMobile) {
        //     this.tripCategoryWrap.nativeElement.scrollIntoView({behavior: "smooth"});
        // }
    };
    VisitorTripSideBarComponent.prototype.scrollToBottom = function () {
        var _this = this;
        setTimeout(function () {
            _this.cardWrap.nativeElement.scrollTop = _this.cardWrap.nativeElement.scrollHeight;
            _this.cardContainer.nativeElement.scrollTop = _this.cardContainer.nativeElement.scrollHeight;
            if (_this.isMobile) {
                _this.parent.tripWrap.nativeElement.scrollTop = _this.parent.tripWrap.nativeElement.scrollHeight;
            }
        });
    };
    VisitorTripSideBarComponent.prototype.afterSetTrips = function (isShared, tripIndex) {
        var _this = this;
        this.addGotoUserTripCount();
        this.detailsPanel.closeDetails();
        this.parent.searchText = null;
        this.parent.isSearchDisabled = true;
        this.parent.from = null;
        this.parent.to = null;
        this.parent.isStarted = true;
        this.cardWrap.nativeElement.style.overflowY = 'auto';
        this.cardWrap.nativeElement.style.height = 'auto';
        if (isShared || (this.parent.urlTripFromUserID && this.parent.urlTripFromUserID !== this.userFacebookID)) {
            this.loadSharedTripsInLocalStorage(this.parent.urlTripFromUserID);
        }
        else {
            this.userFacebookID ? this.loadTripsInLocalStorageByUserId() : this.loadTripsInLocalStorage();
        }
        if (!isNullOrUndefined(tripIndex)) {
            var targetTrip = this.trips && this.trips.length > tripIndex ? this.trips[tripIndex] : null;
            if (!targetTrip) {
                alert('Wrong trip Id, please check!');
                this.switchToTrip(false);
                return;
            }
            this.displayingOn = 'trip';
            setTimeout(function () {
                _this.enterTrip(tripIndex);
            }, 200);
            return;
        }
        this.backToTripList();
        if (!this.trips || !this.trips.length) {
            this.trips = [];
            this.isShowFilter && this.toggleFilter(true);
            this.displayingOn = 'trip';
            this.showingCount = null;
            setTimeout(function () {
                _this.cardWrap.nativeElement.style.height = 'auto';
                if (!_this.trips.length) {
                    _this.parent.isShowDirectionMap = false;
                }
            });
            return;
        }
        if (this.isEventEnabled) {
            this.getEventsFromCache().subscribe(function (events) {
                _this.trips = _this.setDetaultImages(_this.trips);
                _this.afterSetDefaultImages();
            });
        }
        else {
            this.afterSetDefaultImages();
        }
    };
    VisitorTripSideBarComponent.prototype.addGotoUserTripCount = function () {
        this.analytics = new HubAnalytics();
        this.analytics.tripPlanner.userTripClickCount = 1;
        if (config.isAnalyticsOn) {
            this.visitorApiService.updateTripPlanerAnalytics(this.hubName, this.analytics).subscribe();
        }
    };
    VisitorTripSideBarComponent.prototype.afterSetDefaultImages = function () {
        var _this = this;
        this.isShowFilter && this.toggleFilter(true);
        this.displayingOn = 'trip';
        this.showingCount = null;
        if (!this.isMobile) {
            setTimeout(function () {
                _this.cardWrap.nativeElement.style.maxHeight = _this.cardContainerMaxHeightForTrip;
                _this.cardWrap.nativeElement.style.height = 'auto';
            }, 100);
            if (this.trips && this.trips.length) {
                this.trips[0].isEventImageProcessed = true;
                this.parent.showDirectionMap(this.trips[0]);
                setTimeout(function () {
                    _this.parent.direction.showBanner();
                }, 200);
            }
            else {
                this.backToWelcomePage();
            }
        }
        //this.getTripCount();
        this.scrollToTop();
    };
    VisitorTripSideBarComponent.prototype.backToWelcomePage = function () {
        this.parent.isShowDirectionMap = false;
        this.parent.isShowNormalMap = false;
        this.parent.isShowTour = false;
    };
    VisitorTripSideBarComponent.prototype.setPaggination = function (data) {
        if (this.setNoItemPagination(data)) {
            return;
        }
        this.paginationIndex = 0;
        if (data.length > this.paginationPageLimit) {
            var max = this.paginationPageLimit * (this.paginationIndex + 1);
            max = max < this.allEventsOrPlaces.length ? max : this.allEventsOrPlaces.length;
            this.displayingOn === 'event' ? (this.events = data.slice(0, max)) : (this.places = data.slice(0, max));
            this.showingCount = this.paginationPageLimit * this.paginationIndex + 1 + " - " + max;
            this.noMoreNext = false;
            this.noMoreBack = true;
        }
        else {
            this.displayingOn === 'event' ? (this.events = data) : (this.places = data);
            this.showingCount = null;
        }
        this.processMultiColumnsItems();
    };
    VisitorTripSideBarComponent.prototype.setNoItemPagination = function (data) {
        if (!data || !data.length) {
            this.noMoreNext = true;
            this.noMoreBack = true;
            this.showingCount = null;
            if (this.displayingOn === 'event') {
                this.events = [];
                this.eventRows = [];
            }
            else if (this.displayingOn === 'place') {
                this.places = [];
                this.placeRows = [];
            }
            this.cardWrap.nativeElement.style.height = 'auto';
            return true;
        }
    };
    VisitorTripSideBarComponent.prototype.setFacebookUserID = function () {
        if (this.isUserloggedIn) {
            this.userFacebookID = SocialLoginPopupComponent.userId;
        }
        else {
            this.userFacebookID = null;
        }
    };
    VisitorTripSideBarComponent.prototype.setEventDateRange = function (from, to) {
        if (from && !to) {
            this.filterDateRangeText = " (after " + EventTimeService.toShortDateFormat(from) + ")";
        }
        else if (!from && to) {
            this.filterDateRangeText = " (before " + EventTimeService.toShortDateFormat(to) + ")";
        }
        else if (from && to) {
            this.filterDateRangeText = " (" + EventTimeService.toShortDateFormat(from) + " - " + EventTimeService.toShortDateFormat(to) + ")";
        }
    };
    VisitorTripSideBarComponent.prototype.afterGotTours = function (data, tourId) {
        var _this = this;
        if (this.parent.featuresToggle.multipleCities) {
            if (!this.parent.isForTourList && this.parent.currentRegion && this.parent.currentRegion.tours) {
                data = data.filter(function (x) { return _this.parent.currentRegion.tours.any(function (y) { return x._id === y.id; }); });
            }
        }
        this.tours = data;
        this.isShowFilter && this.toggleFilter(true);
        this.displayingOn = 'tour';
        this.parent.isShowNormalMap = false;
        this.parent.isShowDirectionMap = false;
        this.currentTour = null;
        this.showingCount = null;
        if (!this.isMobile) {
            this.cardContainer.nativeElement.style.maxHeight = this.cardContainerFullHeight;
            // this.cardWrap.nativeElement.style.height = this.cardContainerFullHeight;
            this.cardWrap.nativeElement.style.maxHeight = 'none';
        }
        else {
            this.tourSpinner = [];
            this.tours.forEach(function (x) {
                _this.tourSpinner.push(false);
            });
        }
        this.scrollToTop();
        if (tourId) {
            this.parent.setPDFLoadingTip([8, 9, 10, 11]);
            var tour_1 = this.tours.filter(function (x) { return x._id === tourId; }).first();
            if (tour_1) {
                setTimeout(function () {
                    _this.parent.showTourDetail(tour_1);
                    _this.hideMask();
                });
            }
            else {
                alert('This a wrong itinerary id, please check!');
                this.switchToTours();
            }
        }
        else {
            this.showTourWaterfall.emit(this.tours);
            this.hideMask();
        }
        this.analytics = new HubAnalytics();
        this.analytics.tripPlanner.tourClickCount = 1;
        if (config.isAnalyticsOn) {
            this.visitorApiService.updateTripPlanerAnalytics(this.hubName, this.analytics).subscribe();
        }
    };
    VisitorTripSideBarComponent.prototype.fitBounds = function () {
        var _this = this;
        this.googleMapService.getGoogle().then(function () {
            _this.latLngBounds = new google.maps.LatLngBounds();
            var target = null;
            if (_this.displayingOn === 'event') {
                target = _this.events;
            }
            else if (_this.displayingOn === 'place') {
                target = _this.places;
            }
            target.forEach(function (x) {
                if (!isNullOrUndefined(x.address.lat) && !isNullOrUndefined(x.address.lng)) {
                    _this.latLngBounds.extend(new google.maps.LatLng(x.address.lat, x.address.lng));
                }
            });
        });
    };
    VisitorTripSideBarComponent.prototype.hideMapMobileTrigger = function ($event) {
        // if (this.mobileMapTrigger) {
        //     this.mobileMapTrigger.nativeElement.style.display = 'none';
        // }
        if (this.isMobile) {
            this.showTripDetailModalForMobile($event.item, $event.item.startTime ? 'event' : 'place', this.displayingOn === 'tour');
        }
    };
    VisitorTripSideBarComponent.prototype.showMask = function () {
        this.isSwitching = true;
    };
    VisitorTripSideBarComponent.prototype.hideMask = function () {
        var _this = this;
        setTimeout(function () {
            _this.isSwitching = false;
        }, 500);
    };
    VisitorTripSideBarComponent.prototype.takeSettingsAndProcess = function () {
        var _this = this;
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.toggle) {
                _this.featuresToggle = command.toggle;
                if (_this.isAllPlaceCategoriesTurnedOff) {
                    _this.featuresToggle.placeCalendar = false;
                }
                for (var category in _this.filter.place) {
                    if (_this.featuresToggle.placeCategory[category]) {
                        _this.category.place = _this.filter.place[category].key;
                        _this.filter.place[category].value = true;
                        break;
                    }
                }
            }
            if (command.customSettings) {
                _this.logoUrl =
                    isNullOrUndefined(command.customSettings.logo) ||
                        isNullOrUndefined(command.customSettings.logo.isDefault) ||
                        command.customSettings.logo.isDefault
                        ? null
                        : command.customSettings.logo.url;
                _this.logo = command.customSettings.logo;
                if (command.customSettings.tourSidebarImage) {
                    if (command.customSettings.tourSidebarImage.isDefault) {
                        _this.tourSideImg = _this.imageService.imageSourceUrl(_this.tourSideImg);
                    }
                    else {
                        _this.tourSideImg = _this.imageService.imageSourceUrl(command.customSettings.tourSidebarImage.url);
                    }
                }
                _this.detailsStyle = command.customSettings.tripPlannerDetailsStyle;
                _this.customDefaultPlaceCategory = command.customSettings.customDefaultPlaceCategory;
                console.log('customDefaultPlaceCategory ni trip', _this.customDefaultPlaceCategory);
            }
            _this.dataSource = command.dataSource || _this.dataSource;
            _this.style = command.style ? command.style : _this.style;
            setTimeout(function () {
                if (!_this.isMobile) {
                    if (!_this.parent.isForTourList && !_this.parent.urlTripID && !_this.parent.urlTourID) {
                        setTimeout(function () {
                            if (_this.featuresToggle.multipleCities) {
                                // setTimeout(() => {
                                //     this.switchToTours();
                                // }, 300);
                                // return;
                                return;
                            }
                            if (_this.isPlaceEnabled) {
                                _this.switchToPlaces(true);
                            }
                            else if (_this.isEventEnabled) {
                                _this.switchToEvents(true);
                            }
                            else {
                                _this.switchToTours();
                            }
                        });
                    }
                }
                else {
                    if (_this.featuresToggle.multipleCities) {
                        _this.parent.isShowSidebarOnMobile = true;
                        setTimeout(function () {
                            _this.switchToTours();
                        }, 300);
                        return;
                    }
                    _this.setEventDateRange(_this.parent.from, _this.parent.to);
                    _this.fromForMobile = _this.parent.from;
                    _this.toForMobile = _this.parent.to;
                }
            });
        });
    };
    VisitorTripSideBarComponent.prototype.listenShowOnMap = function () {
        var _this = this;
        this.visitorTripStore.tripCommand.takeUntil(this.isDestroyed).subscribe(function (item) {
            if (!_this.isMobile || isNullOrUndefined(item.item)) {
                return;
            }
            if (!isNullOrUndefined(item.item)) {
                var items = [];
                items = _this.displayingOn === 'event' ? _this.events : _this.displayingOn === 'place' ? _this.places : [];
                var targetIndex_1 = 0;
                items.forEach(function (x, index) {
                    if (x._id === item.item._id) {
                        targetIndex_1 = index;
                        return;
                    }
                });
                var obj = {
                    items: items,
                    index: targetIndex_1,
                };
                _this.parent.showOnMap(obj);
            }
        });
    };
    return VisitorTripSideBarComponent;
}(BaseComponent));
export { VisitorTripSideBarComponent };
var HubAnalytics = /** @class */ (function () {
    function HubAnalytics() {
        this.tripPlanner = {
            eventClickCount: 0,
            placeClickCount: 0,
            tourClickCount: 0,
            userTripClickCount: 0,
            shareClickCount: 0,
        };
    }
    return HubAnalytics;
}());
export { HubAnalytics };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.side.bar/visitor.trip.side.bar.component.ts.pre-build-optimizer.js